import axios from 'axios';
import { LoginInput } from './types';

const APP_API_URL = 'https://dashboard-clients-public.prod.tapila.cloud';
const APP_API_KEY = 'HaHO8Ia4sv6fu7DIT7VGB64bHpuywMBc3k7lygEG';

export type LoginResponse = {
  accessToken: string;
  refreshToken: string;
};

export default {
  login: async ({ username, password }: LoginInput): Promise<LoginResponse> => {
    try {
      const { data } = await axios.post<LoginResponse>(`${APP_API_URL}/login`, {
        clientUsername: username,
        password,
      }, {
        headers: {
          'x-api-key': APP_API_KEY,
        }
      });

      return data;
    } catch (err) {
      throw err;
    }
  },
  check: async (token: string): Promise<any> => {
    try {
      const { data } = await axios.post<LoginResponse>(`${APP_API_URL}/authorizer`, {
        token
      }, {
        headers: {
          'x-api-key': APP_API_KEY,
        }
      });

      return data;
    } catch (err) {
      throw err;
    }
  }
}
